import $ from 'jquery';

import Overlay from 'ol/Overlay';

function PopUp(options) {
    this._options = options;

    this._feature = null;
    this._overlay = new Overlay({
        element: options.target,
        autoPan: false
    });

    this._visible = false;
    this._timeout = null;

    this._offset = options.offset;
    this._margin = options.margin;

    this._map = options.map;
    this._map.map.addOverlay(this._overlay);
}

PopUp.prototype.on = function (event, callback) {
    $(this._options.target).on(event, callback);
};

PopUp.prototype.is = function (event) {
    return $(this._options.target).is(event);
};

PopUp.prototype.open = function (feature, content, callback) {

    callback = typeof callback === 'undefined' ? null : callback;
    if (this._feature === feature) {
        return;
    }

    this._feature = feature;
    this._options.target.innerHTML = content;
    $(this._options.target).show();

    this._overlay.setPosition(feature.getGeometry().getCoordinates());

    if (callback) {
        callback();
    }

    this.updateOffset();
};

PopUp.prototype.close = function () {
    this._feature = null;
    this._overlay.setPosition(undefined);
};

PopUp.prototype.updateOffset = function () {
    if (this._feature) {
        let pin   = this._map.abgeordnete[this._feature.getId()].pin;
        let scale = this._map.scale(this._map.view.getResolution());

        let position = this._map.map.getPixelFromCoordinate(this._overlay.getPosition());
        let offset = [(pin.x + this._offset.x) * scale, (pin.y + this._offset.y) * scale];

        let overlay_size = [$(this._options.target).outerWidth(true), $(this._options.target).outerHeight(true)];
        let map_size = [$(this._map.options.target).width(), $(this._map.options.target).height()];

        let left = offset[0] + (-this._margin.left * scale) - overlay_size[0];
        let right = offset[0] + (this._margin.right * scale);

        let top = offset[1] + (-this._margin.top * scale) - overlay_size[1];
        let bottom = offset[1] + (this._margin.bottom * scale);

        let overflow = position[1] + bottom + overlay_size[1] > map_size[1] && position[0] + left + overlay_size[0] > 30;

        let x = overflow?left:right;
        let y = overflow?top:bottom;

        this._overlay.setOffset([x, y]);
    }
};

PopUp.prototype.timeoutAfter = function (milliseconds) {
    let popup = this;

    popup._visible = false;

    if (popup._timeout === null) {
        popup._timeout = setTimeout(function() {
            if (!popup._visible) {
                popup.close();
            }
        }, milliseconds);
    }
};

PopUp.prototype.clearTimeout = function () {
    let popup = this;

    clearTimeout(popup._timeout);
    popup._visible = true;
    popup._timeout = null;
};

export default PopUp;